import smoothReveal from 'frontend/unpoly/javascripts/util/smooth_reveal'
import { mobileBreakpoint } from 'shared/javascripts/util/mobile_breakpoint'

up.compiler(
  '[data-outline]',
  (
    outline,
    {
      revealPaddingMobile,
      revealPaddingDesktop,
    }: { revealPaddingMobile: number; revealPaddingDesktop: number },
  ) => {
    const outlineLinks = outline.querySelectorAll('[data-outline-link]')

    function activateLinks() {
      for (let i = 0; i < outlineLinks.length; ++i) {
        const outlineLink = outlineLinks[i]

        outlineLink.addEventListener('click', (event) => {
          event.preventDefault()

          const index = outlineLink.getAttribute('data-outline-link')
          const linkedElements = document.querySelectorAll<HTMLElement>(
            '[data-outline-index="' + index + '"]',
          )
          // find the first visible one
          const linkedElement = Array.from(linkedElements).find(
            (element) => element.offsetParent !== null,
          )

          if (!linkedElement) return

          const revealPadding = mobileBreakpoint.matches
            ? revealPaddingMobile
            : revealPaddingDesktop

          void smoothReveal(linkedElement, revealPadding).then(() => {
            // element might have moved since we loaded some pictures
            void smoothReveal(linkedElement, revealPadding)
          })
        })
      }
    }

    activateLinks()
  },
)
